import { HTMLProps, memo, NamedExoticComponent } from 'react';
import { IMAGE_SHAPES, IMAGE_SIZES, imageTypes } from '@/components/dorsaImage/imageTypes';
import Image from 'next/image';

interface AbImagePropsInterface extends HTMLProps<HTMLImageElement> {
    config: {
        shape: IMAGE_SHAPES;
        size: IMAGE_SIZES;
    };
}

const DorsaImage: NamedExoticComponent<AbImagePropsInterface> = memo(
    ({ src, config: { shape, size }, alt, ...props }) => {
        let srcSet = '';
        let sizes = '';

        /* todo: later add other screen size breakpoints, beside the xs (sm, md, lg ...) */
        Object.values(imageTypes).forEach((breakpoint) => {
            srcSet = src + `?format=webp&sh=0.5&width=${breakpoint.dimensions[shape][size].width}`;
            sizes =
                (sizes ? ', ' : '') +
                `(max-width: ${breakpoint.threshold}) ${breakpoint.threshold}px`;
        });

        if (!src) return null;

        return (
            <Image
                src={srcSet}
                width={imageTypes['XS']?.dimensions[shape][size].width}
                height={100}
                sizes={sizes}
                // priority
                {...props}
                alt={alt || ''}
                loading={props?.loading || 'lazy'}
            />
        );
    }
);

DorsaImage.displayName = 'DorsaImage';

export default DorsaImage;
